<script lang="ts">
	export let loading: boolean = false;
</script>

<div class="flex relative">
	<slot />
	{#if loading}
		<div class="flex flex-col flex-grow absolute z-30 w-full h-full opacity-70 bg-black">
			<svg
				version="1.1"
				id="L4"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 100 100"
				enable-background="new 0 0 0 0"
				xml:space="preserve"
			>
				<circle fill="#fff" stroke="none" cx="26" cy="50" r="4">
					<animate
						attributeName="opacity"
						dur="1s"
						values="0;1;0"
						repeatCount="indefinite"
						begin="0.1"
					/>
				</circle>
				<circle fill="#fff" stroke="none" cx="41" cy="50" r="4">
					<animate
						attributeName="opacity"
						dur="1s"
						values="0;1;0"
						repeatCount="indefinite"
						begin="0.2"
					/>
				</circle>
				<circle fill="#fff" stroke="none" cx="56" cy="50" r="4">
					<animate
						attributeName="opacity"
						dur="1s"
						values="0;1;0"
						repeatCount="indefinite"
						begin="0.3"
					/>
				</circle>
				<circle fill="#fff" stroke="none" cx="71" cy="50" r="4">
					<animate
						attributeName="opacity"
						dur="1s"
						values="0;1;0"
						repeatCount="indefinite"
						begin="0.3"
					/>
				</circle>
				<circle fill="#fff" stroke="none" cx="86" cy="50" r="4">
					<animate
						attributeName="opacity"
						dur="1s"
						values="0;1;0"
						repeatCount="indefinite"
						begin="0.3"
					/>
				</circle>
			</svg>
		</div>
	{/if}
</div>
